import {useState} from "react";
import {Rules, ValidationErrors, Validator} from "common";
import {RegisterForm} from "./registerAPI";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {registerAsync, selectIdentityStatus} from "../../../identitySlice";

export interface RegisterFormProps {
  defaultValues?: RegisterForm;
  onSuccessRegister: Function;
}

export interface TokenData {
  email: string;
}

export function validateRegister(values: RegisterForm) {
  let rules: Rules = {
    first_name: Validator.rule.string().required(),
    last_name: Validator.rule.string().required(),
    email: Validator.rule.string().required(),
    password: Validator.rule.string().required(),
    account_name: Validator.rule.string().required(),
  };

  return Validator.validate(rules, values, "Register");
}

export default function useRegisterForm({defaultValues, onSuccessRegister}: RegisterFormProps) {
  const [item, setItem] = useState<RegisterForm>(
    defaultValues || ({} as RegisterForm)
  );
  const [errors, setErrors] = useState<ValidationErrors>({});
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectIdentityStatus);

  function onChange(values: RegisterForm) {
    setItem(values);
  }

  async function process() {
    const result = validateRegister(item);
    setErrors(result.errors);

    if (!result.success) {
      return;
    }

    const response = await dispatch(registerAsync({item}));

    if (response.meta.requestStatus === "fulfilled") {
      onSuccessRegister(item.email);
    } else {
      if (response.payload) {
        setErrors(response.payload.form_errors);
      }
    }
  }

  return {
    item,
    errors,
    loading: status === "loading",
    process,
    onChange
  };
}